import { numericSpace } from '@ardoq/design-tokens';

const TAB_HEIGHT = 34;
const TAB_UNDERLINE_GAP = 1;

export const TAB_UNDERLINE_HEIGHT = numericSpace.xxsmall;
export const TAB_UNDERLINE_SPACE = TAB_UNDERLINE_HEIGHT + TAB_UNDERLINE_GAP;
export const TAB_HOVER_HEIGHT = TAB_HEIGHT - TAB_UNDERLINE_SPACE;
